export default [
   {
      "value": "CEO",
      "label": "CEO"
   }, {
      "value": "Estimation",
      "label": "Estimation"
   }, {
      "value": "Sales and Marketing",
      "label": "Sales and Marketing المبيعات"
   }, {
      "label": "Store المخزن",
      "value": "Store"
   }, {
      "label": "QC الجوده",
      "value": "QC"
   }, {
      "label": "safety الصحه و السلامة",
      "value": "safety"
   }, {
      "value": "Production",
      "label": "Production الانتاج"
   }, {
      "label": "Prepress ما قبل الطباعه",
      "value": "Prepress"
   }, {
      "value": "QA",
      "label": "QA إدارة الجوده"
   }, {
      "value": "Maintenance",
      "label": "Maintenance الصيانه"
   }, {
      "label": "Purchasing المشتريات",
      "value": "Purchasing"
   }, {
      "value": "IT",
      "label": "IT"
   }, {
      "value": "HR",
      "label": "HR الموارد البشريه"
   }, {
      "value": "Finance",
      "label": "Finance المحاسبه"
   }
]